import $ from "cash-dom"

const notify = (msg, type = "notice") => {
  const callback = () => {
    notify_now(msg, type)
    document.removeEventListener("turbo:load", callback)
  }
  document.addEventListener("turbo:load", callback)
}

export const notify_now = (msg, type = "notice") => {
  $("#flash")
    .append(`<div class="alert ${type}" data-flash-target="alert">${msg}</div>`)
}
export default notify
